import { Vue, Component, Prop } from "vue-property-decorator";
import md5 from "crypto-js/md5";
import { serializeArray } from "../utils/form";
import assign from "lodash-es/assign";

@Component
class PaymentForm extends Vue {
    @Prop({type: String}) public pspid: string;
    @Prop({type: String}) public currentPage: string;
    @Prop({type: String}) public errorPage: string;
    @Prop({type: String}) public successPage: string;
    @Prop({type: String}) public successPageEz: string;

    public language = "de_DE";
    private defaultForm: HTMLFormElement | null = null;
    private paymentForm: HTMLFormElement | null = null;

    public shaSignature = "";
    public orderid = "";
    public errorMessage = "";

    public payment = "online";
    public firstname = "";
    public lastname = "";
    public address = "";
    public postbox = "";
    public zip = "";
    public city = "";
    public phone = "";
    public email = "";

    private async getSHA1(data: any): Promise<string | {}> {
        return new Promise(async (resolve, reject) => {
            try {
                const hashRequest = await fetch(window.$$currentPath + "/.servlets/payment/", {
                    method: "POST",
                    credentials: "include",
                    body: JSON.stringify(data),
                });

                if (hashRequest.ok) { resolve(await hashRequest.text()); }
                else { reject({
                        request: hashRequest,
                        error: Error("unable to create the hash"),
                    });
                }
            }
            catch (error) { reject(error); }
        });
    }

    /**
     * Generate on order ID. Mainly for Post Finance.
     * @see https://e-payment-postfinance.v-psp.com/en/en/guides/integration%20guides/e-commerce/link-your-website-to-the-payment-page
     */
    protected generateOrderID(form: HTMLFormElement): string {
        let hashString = "";
        const values = serializeArray(form);

        for (const prop in values) {
            if (values.hasOwnProperty(prop)) {
                hashString += `${prop}=${values[prop]};`;
            }
        }

        hashString += Date.now().toString();
        return md5(hashString).toString();
    }

    /**
     * Generate an SHA1 check for PostFinance
     * also used to generate the order ID
     * @see https://e-payment-postfinance.v-psp.com/en/en/guides/integration%20guides/e-commerce/security-pre-payment-check
     */
    public validateForm() {
        if (this.defaultForm && this.paymentForm) {
            this.errorMessage = "";

            if (this.defaultForm.checkValidity()) {
                this.orderid = this.generateOrderID(this.defaultForm);

                this.$nextTick(async () => {
                    const data = assign({}, serializeArray(this.defaultForm as HTMLFormElement), serializeArray(this.paymentForm as HTMLFormElement));

                    try { this.shaSignature = await this.getSHA1(data) as string; }
                    catch (_unusedError) {
                        window.location.assign(this.errorPage);
                        return;
                    }

                    this.$nextTick(() => {
                        if (this.payment === "online") {
                            (this.paymentForm as HTMLFormElement).submit();
                        }
                        else if (this.payment === "transfer") {
                            window.location.assign(this.successPageEz);
                        }
                    });
                });
            }
            else {
                this.errorMessage = this.$t("fill-all").toString();
            }
        }
    }

    public mounted() {
        this.defaultForm = this.$el.querySelector(".js-default-form") as HTMLFormElement;
        this.paymentForm = this.$el.querySelector(".js-payment-form") as HTMLFormElement;
    }
}

export default PaymentForm;



// WEBPACK FOOTER //
// ./src/scripts/components/payment-form.ts